import React, { Component } from 'react';
import Button from './../Button/Button';
import quoteMark from 'assets/images/quotation.svg';

export default class TextBanner extends Component {
  render() {
    const quoteImage = this.props.quoteImage;
    const quoteTitle = this.props.quoteTitle;
    const quotePerson = this.props.quotePerson;
    var divStyle = {
      backgroundImage: 'url(' + quoteImage + ')',
    };
    return (
      <div
        className={'textBanner' + (this.props.extraClasses ? ' ' + this.props.extraClasses : '')}
        style={divStyle}
        >
        {quoteTitle && 
          <h2>
            <img src={quoteMark} alt={quoteMark}/>
            {quoteTitle}
            <img src={quoteMark} alt={quoteMark}/>
          </h2>}
        {quotePerson && <h5>{quotePerson}</h5>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TextBanner/TextBanner.jsx